module.exports = __webpack_public_path__ + "static/media/patient_done.5816ac46.png";